import { Toolbox as Value } from "@reactivated";

import { Banner } from "../Banner";
import { BgTransitionSentinel } from "../BgTransitionSentinel";
import { CardGrid } from "../CardGrid";
import { CirclesPromo } from "../CirclesPromo";
import { ColoredCardGrid } from "../ColoredCardGrid";
import { ColumnCarousel } from "../ColumnCarousel";
import { DisplayCarousel } from "../DisplayCarousel";
import { EventsList } from "../EventsList";
import { FAQ } from "../FAQ";
import { FeaturedResource } from "../FeaturedResource";
import { FeaturedRichtextBlock } from "../FeaturedRichtext";
import { FiftyWaysCards } from "../FiftyWaysCards";
import { Figure } from "../Figure";
import { FullbleedMedia } from "../FullbleedMedia";
import { FullbleedMediaHero } from "../FullbleedMediaHero";
import { GuidesCarousel } from "../GuidesCarousel";
import { HeroArchive } from "../HeroArchive";
import { HeroGuide } from "../HeroGuide";
import { HeroImage } from "../HeroImage";
import { HeroStorytelling } from "../HeroStorytelling";
import { HorizontalScrollCards } from "../HorizontalScrollCards";
import { LinkList } from "../LinkList";
import { LogoBar } from "../LogoBar";
import { LogoMarquee } from "../LogoMarquee";
import { Newsletter } from "../Newsletter";
import { PromoColumns } from "../PromoColumns";
import { PromoImageCards } from "../PromoImageCards";
import { RichTextBlock } from "../RichText";
import { ScrollNavMenuBlock, ScrollNavMenuItemBlock } from "../ScrollNav";
import { AnimatedShowcase, StandaloneShowcase } from "../Showcase";
import { ShowcaseImageCards } from "../ShowcaseImageCards";
import { SpacerBlock } from "../SpacerBlock";
import { SplitBlock } from "../SplitBlock";
import { SplitContentCarousel } from "../SplitContentCarousel";
import { SplitTestimonialCarousel } from "../SplitTestimonialCarousel";
import { StickyBar } from "../StickyBar";
import { TabbedContent } from "../TabbedContent";
import { TestimonialCarousel } from "../TestimonialCarousel";
import { TextRotator } from "../TextRotator";
import { VideoEmbed } from "../VideoEmbed";
import { VideoGrid } from "../VideoGrid";
import { StrictBlockMap } from "./TrackedStreamField";

export const toolboxBaseComponents: Omit<
    StrictBlockMap<Value>,
    "reusable_content"
> = {
    animated_showcase: AnimatedShowcase,
    banner: Banner,
    bg_transition_sentinel: BgTransitionSentinel,
    card_grid: CardGrid,
    circles_promo: CirclesPromo,
    colored_card_grid: ColoredCardGrid,
    column_carousel: ColumnCarousel,
    columns: PromoColumns,
    display_carousel: DisplayCarousel,
    faq: FAQ,
    featured_richtext: FeaturedRichtextBlock,
    featured_resource: FeaturedResource,
    fifty_ways_cards: FiftyWaysCards,
    figure: Figure,
    fullbleed_media_hero: FullbleedMediaHero,
    fullbleed_media: FullbleedMedia,
    guides: GuidesCarousel,
    hero_archive: HeroArchive,
    hero_guide: HeroGuide,
    hero_image: HeroImage,
    hero_storytelling: HeroStorytelling,
    horizontal_scroll_cards: HorizontalScrollCards,
    link_list: LinkList,
    logo_bar: LogoBar,
    logo_marquee: LogoMarquee,
    newsletter: Newsletter,
    promo_image_cards: PromoImageCards,
    rich_text: RichTextBlock,
    showcase: StandaloneShowcase,
    showcase_image_cards: ShowcaseImageCards,
    spacer: SpacerBlock,
    split: SplitBlock,
    split_content_carousel: SplitContentCarousel,
    split_testimonial_carousel: SplitTestimonialCarousel,
    sticky_bar: StickyBar,
    tabbed_content: TabbedContent,
    testimonial_carousel: TestimonialCarousel,
    text_rotator: TextRotator,
    video_embed: VideoEmbed,
    scroll_nav: ScrollNavMenuBlock,
    scroll_nav_stop: ScrollNavMenuItemBlock,
    video_grid: VideoGrid,
    event_list: EventsList,
};
